import { useState } from "react";
import {
  Modal,
  Toast,
  ToastContainer,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Download, Copy } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";

export const ModalQrCode = ({ show, onHide, item }) => {
  const [toast, setToast] = useState({
    show: false,
    message: "",
  });

  if (!item) return null;

  const canvasId = "qr-code-canvas";
  const qrUrl = `${window.location.origin}/confirmar-presenca/${item.tokenQr}`;

  function showToast(message: string) {
    setToast({ show: true, message });
  }

  function downloadQrCode() {
    const qrCanvas = document.getElementById(canvasId) as HTMLCanvasElement | null;
    if (!qrCanvas) return;
    const padding = 32;
    const outCanvas = document.createElement("canvas");
    outCanvas.width = qrCanvas.width + padding * 2;
    outCanvas.height = qrCanvas.height + padding * 2;
    const ctx = outCanvas.getContext("2d");
    if (!ctx) return;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, outCanvas.width, outCanvas.height);
    ctx.drawImage(qrCanvas, padding, padding);
    const image = outCanvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = `qrcode-${item.id}.png`;
    link.click();
    showToast("QR Code baixado!");
  }

  function copiarTokenFallback(texto: string) {
    const textArea = document.createElement("textarea");
    textArea.value = texto;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    textArea.style.opacity = "0";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, textArea.value.length);

    try {
      const sucesso = document.execCommand("copy");

      if (sucesso) {
        showToast("Token copiado para a área de transferência!");
      } else {
        showToast("Não foi possível copiar o token.");
      }
    } catch (error) {
      console.error("Erro ao copiar token com fallback:", error);
      showToast("Não foi possível copiar o token.");
    } finally {
      document.body.removeChild(textArea);
    }
  }

  function copiarToken() {
    const texto = item.tokenQr;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(texto)
          .then(() => {
            showToast("Token copiado para a área de transferência!");
          })
          .catch((error) => {
            console.error("Erro ao copiar token com clipboard API:", error);
            copiarTokenFallback(texto);
          });
        return;
      }

      copiarTokenFallback(texto);
    } catch (error) {
      console.error("Erro ao copiar token:", error);
      showToast("Não foi possível copiar o token.");
    }
  }

  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Detalhes do QR Code</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <div
            style={{
              display: "inline-block",
              backgroundColor: "#ffffff",
              padding: "16px",
              borderRadius: "8px",
            }}
          >
            <QRCodeCanvas
              id={canvasId}
              value={qrUrl}
              size={220}
              level="H"
              bgColor="#ffffff"
              fgColor="#000000"
            />
          </div>

          <div
            className="d-flex justify-content-center align-items-center mt-3"
            style={{ cursor: "pointer", gap: 8 }}
            onClick={downloadQrCode}
          >
            <Download size={18} />
            <span>Fazer download</span>
          </div>

          <hr />

          <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
            <strong>Token:</strong>
            <span className="text-break">{item.tokenQr}</span>

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-copiar-token">Clique para copiar o token</Tooltip>}
            >
              <span
                style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
                onClick={copiarToken}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    copiarToken();
                  }
                }}
                aria-label="Copiar token"
                title="Copiar token"
              >
                <Copy size={18} />
              </span>
            </OverlayTrigger>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer position="bottom-center" className="p-3">
        <Toast
          bg="success"
          onClose={() => setToast({ ...toast, show: false })}
          show={toast.show}
          delay={2500}
          autohide
        >
          <Toast.Body className="text-white text-center">
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};